import { isVersionAtLeast } from '@/shared/lib';
import _ from 'lodash';
import { REPORT_TYPE, REPORT_VERSION } from '../config/inboxDetails';

/**
 * Identifies an inbox report that uses the newer notification and event report format. Requires the report's formatVersion to be at least REPORT_VERSION.V_2_0_2 and its type to be Event or Notification.
 *
 * @param report - Report carrying formatVersion and type.
 * @returns True when the report is a new-format event or notification report.
 */
const checkNewNotiEventReport = (report: { formatVersion: string; type: string }) => {
  const { formatVersion, type } = report || {};
  return (
    isVersionAtLeast(formatVersion, REPORT_VERSION.V_2_0_2) &&
    _.includes([REPORT_TYPE.EVENT, REPORT_TYPE.NOTIFICATION], type)
  );
};

export { checkNewNotiEventReport };
